import { render, staticRenderFns } from "./CustomerListByUserID.vue?vue&type=template&id=12df7994&"
import script from "./CustomerListByUserID.vue?vue&type=script&lang=js&"
export * from "./CustomerListByUserID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports